import * as actionTypes from 'constants/ActionTypes';

export function getPorts(pagination) {
    return {
        type: actionTypes.GET_PORTS.REQUEST,
        pagination,
    };
}

export function getPort(data) {
    return {
        type: actionTypes.GET_PORT.REQUEST,
        data,
    };
}

export function getAllPorts() {
    return {
        type: actionTypes.GET_ALL_PORTS.REQUEST,
    };
}

export function savePort(item) {
    return {
        type: actionTypes.SAVE_PORT,
        item,
    };
}

export function updatePortSuggestions(suggestions) {
    return {
        type: actionTypes.UPDATE_PORT_SUGGESTIONS,
        suggestions,
    };
}

export function updatePortAlt(item) {
    return {
        type: actionTypes.UPDATE_PORT_ALT.REQUEST,
        item,
    };
}

export function updatePort(data) {
    return {
        type: actionTypes.UPDATE_PORT.REQUEST,
        data,
    };
}

export function searchPort(search) {
    return {
        type: actionTypes.SEARCH_PORT,
        search,
    };
}

export function changePort(data) {
    return {
        type: actionTypes.CHANGE_PORT,
        data,
    };
}

export function clearPort() {
    return {
        type: actionTypes.CLEAR_PORT,
    };
}


export function addNewPort(data) {
    return {
        type: actionTypes.ADD_NEW_PORT.REQUEST,
        data,
    };
}




// WEBPACK FOOTER //
// ./app/actions/regions/ports.js